import React, { useState, useContext, useEffect, useRef } from "react";
// import { getAuth, updateProfile, signOut } from "firebase/auth";
// import { db } from "../Firebase/FirebaseConfig";
// import {
//   ref,
//   uploadBytesResumable,
//   getDownloadURL,
//   getStorage,
// } from "firebase/storage";
import { Link, useNavigate } from "react-router-dom";
import { Fade } from "react-reveal";
// import toast, { Toaster } from "react-hot-toast";
import logo from "../../assets/images/mayaLogo.png";
import clsx from 'clsx';

import { AuthContext } from "../../Context/UserContext";
import WelcomePageBanner from "../../assets/images/WelcomePageBanner.png";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { CiCirclePlus } from "react-icons/ci";
import { FaEyeSlash, FaMicrophone, FaMicrophoneSlash } from "react-icons/fa";
import { FaEye } from "react-icons/fa6";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axiosClient from "../../axios-client";
import { TbArrowBackUp } from "react-icons/tb";


function EditPassword() {
  const { user } = useContext(AuthContext);
  const [ErrorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate()
  //password variables
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');


  const [passwordStrength, setPasswordStrength] = useState('');
  const [passwordColor, setPasswordColor] = useState('');

  const checkPasswordStrength = () => {
    const specialchar = /[@#$%^&+=!*_|èàç()/."';:,?ù]/;
    const minLengthRegex = /^.{8,}$/;
    const startLength = /^.{2,}$/;
    const digitRegex = /\d/;
    const lowercaseRegex = /[a-z]/;
    const uppercaseRegex = /[A-Z]/;

    let missingRequirements = [];

    if (!specialchar.test(newPassword)) {
      missingRequirements.push("caractère spécial");
    } else if (!lowercaseRegex.test(newPassword)) {
      missingRequirements.push("minuscule");
    } else if (!uppercaseRegex.test(newPassword)) {
      missingRequirements.push("majuscule");
    } else if (!digitRegex.test(newPassword)) {
      missingRequirements.push("chiffres");
    } else if (!minLengthRegex.test(newPassword)) {
      missingRequirements.push("longueur minimale de 8 caractères");
    }

    if (missingRequirements.length > 0) {
      const missingText = `Vous avez besoin de ${missingRequirements.join(", ")} dans votre mot de passe.`;
      setPasswordStrength(missingText);
      setPasswordColor('text-red-400');
    } else {
      setPasswordStrength('Le mot de passe est correct!');
      setPasswordColor('text-green-500');
    }
  }

  useEffect(() => {
    checkPasswordStrength();
  }, [newPassword]);


  // check the password complexity
  const isPasswordValid = (password) => {
    const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=!*_|èàç()/."';:,?ù])[0-9a-zA-Z@#$%^&+=!*_|èàç()/."';:,?ù]{8,}$/;
    const specialchar = /[@#$%^&+=!*_|èàç()/."';:,?ù]/;
    const minLengthRegex = /^.{8,}$/;
    const digitRegex = /\d/;
    const lowercaseRegex = /[a-z]/;
    const uppercaseRegex = /[A-Z]/;

    let errors = [];

    if (!minLengthRegex.test(password)) {
      errors.push('Le mot de passe doit comporter au moins 8 caractères.');
    }

    if (!digitRegex.test(password)) {
      errors.push('Le mot de passe doit contenir au moins un chiffre.');
    }

    if (!lowercaseRegex.test(password)) {
      errors.push('Le mot de passe doit contenir au moins une lettre minuscule.');
    }

    if (!uppercaseRegex.test(password)) {
      errors.push('Le mot de passe doit contenir au moins une lettre majuscule.');
    }
    if (!specialchar.test(password)) {
      errors.push('Le mot de passe doit contenir au moins un caractère spécial (@#$%^&+=).');
    }
    if (password.length > 20) {
      errors.push('Le mot de passe ne doit pas dépasser 20 caractères.');
    }

    if (errors.length > 0) {
      setErrorMessage(errors[0]);
      return false;
    }

    return passwordRegex.test(password);
  };
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (!isPasswordValid(newPassword)) {
      return;
    }
    try {
      const response = await axiosClient.put(`/change_password/${user.id}/`, {
        old_password: oldPassword,
        new_password: newPassword,
        confirm_password: confirmPassword,
      });
      if (response.data.success) {
        toast.success("le mot de passe est modifié avec succès", {
          position: "top-right",
          autoClose: 3000,
        });

        setConfirmPassword('')
        setNewPassword('')
        setOldPassword('')

      }
      setErrorMessage(response.data.error);
    } catch (err) {
      // console.error(err.response.data.error);
    }
  };
  return (
    <section
      className="py-10 px-3  min-h-[100vh] flex-col flex items-center justify-center relative"  // Ensures the section takes the full height and centers content
      style={{
        background: `url(${WelcomePageBanner})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
      }}
    >
      <ToastContainer />
      <Link
                          onClick={()=>navigate(-1)}
                          className="absolute top-2 left-2 flex items-center justify-center bg-black/20 rounded-full p-2.5 cursor-pointer"
                          title="Se déconnecter"
                        >
                          <TbArrowBackUp size={"26px"} className="text-orange-500" />
                        </Link>
      <div className="pb-5 flex justify-center items-center ">
        <img
          className="h-10 cursor-pointer w-18"
          src={logo}
          alt="NETFLIX"
        />
      </div>
      <div className="w-full bg-white/5 max-w-sm backdrop-blur-md p-5 md:p-10 rounded-lg">

        <h1 className=" text-center text-xl text-white  mb-4 md:mb-8">
          Modifier le mot de passe
        </h1>
        <form className="space-y-4 md:space-y-6 ">
          {ErrorMessage && (
            <h1 className="flex text-sm text-white p-3 bg-red-500 rounded ">

              {ErrorMessage}
            </h1>
          )}
          <div>

            <input
              type="password"
              name="password"
              id="password"
              placeholder="Mot de passe actuel"
              className={"bg-white/10 backdrop-blur text-white sm:text-md rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-3.5 dark:text-gray dark:focus:ring-blue-500 dark:focus:border-blue-500 placeholder:text-gray"}
              required=""
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
            ></input>
          </div>
          <div>

            <input
              type="password"
              name="password"
              id="password"
              placeholder="Nouveau mot de passe"
              className={"bg-white/10 backdrop-blur text-white sm:text-md rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-3.5 dark:text-gray dark:focus:ring-blue-500 dark:focus:border-blue-500 placeholder:text-gray"}
              value={newPassword}
              required=""
              onChange={(e) => setNewPassword(e.target.value)}
              onCopy={(e) => e.preventDefault()}
            ></input>
          </div>
          {newPassword.length > 0 ? (
            <p className={`text-left mt-2 text-sm ${passwordColor}`}>
              {passwordStrength}
            </p>
          ) : ""}

          <div>

            <input
              type="password"
              name="password"
              id="password"
              placeholder="Confirmer mot de passe"
              className={"bg-white/10 backdrop-blur text-white sm:text-md rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-3.5 dark:text-gray dark:focus:ring-blue-500 dark:focus:border-blue-500 placeholder:text-gray"}
              value={confirmPassword}
              required=""
              onChange={(e) => setConfirmPassword(e.target.value)}
            ></input>
          </div>
        </form>
      </div>
      <div className="w-[100%] mt-5 flex items-center justify-center">
        <Link >
          <button onClick={handleFormSubmit} style={{
            background: "linear-gradient(to right, #2ea7a9, #72c9cb)",
          }} className=" lg:w-[100%] px-14 py-3 mt-3 font-medium text-white rounded-md md:text-md flex items-center justify-center ">
            Sauvegarder
          </button>

        </Link>
      </div>
    </section>
  );
}

export default EditPassword;
